import { render, staticRenderFns } from "./FormTemplate.vue?vue&type=template&id=f2a55118"
import script from "./FormTemplate.vue?vue&type=script&lang=js"
export * from "./FormTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports